module.exports = __webpack_public_path__ + "static/media/java.0f55e75e.png";